function changeUnits(units) {
  // Find all size chart wrappers
  const containers = document.querySelectorAll('.size-chart-wrapper');
  if (containers.length > 0) {
    containers.forEach(container => {
      const sizeChart = container.querySelector("#sizeChart");
      if (!sizeChart) return; // Exit if no table is found

      const rows = sizeChart.querySelectorAll("tr");
      
      // Start at i = 1 to skip the header row (th)
      for (let i = 1; i < rows.length; i++) {
        let cols = rows[i].querySelectorAll("td");
        
        // Start at j = 1 to skip the size column (S, M, L)
        for (let j = 1; j < cols.length; j++) {
          // Get the value from the attribute, e.g., data-in or data-cm
          let value = parseFloat(cols[j].getAttribute("data-" + units));

          // Update the cell's text if the value is a valid number
          // .toFixed(1) adds one decimal. Use .toFixed(0) for whole numbers.
          if (!isNaN(value)) {
            cols[j].innerText = value.toFixed(1);
          }
        }
      }

      // Update the 'active' class on the buttons
      const tabs = container.querySelectorAll(".tab");
      tabs.forEach(tab => {
        if (tab.classList.contains("active")) {
          tab.classList.remove("active");
        }
      });
      
      // Add 'active' to the clicked tab (e.g., #cm or #in)
      const activeTab = container.querySelector('#' + units);
      if (activeTab) {
        activeTab.classList.add("active");
      }
    });
  }
}

// Set "cm" as the default units when the page first loads
document.addEventListener("DOMContentLoaded", function() {
  changeUnits("cm");
});

// Listen for a click on the buttons
document.addEventListener("click", e => {
  // If the clicked item doesn't have the class 'st-change-unit', do nothing
  if (!e.target || !e.target.classList.contains("st-change-unit")) {
    return;
  }
  // Get the ID of the button (e.g., "cm" or "in")
  const unit = e.target.id;
  changeUnits(unit);
});

// Listen for your theme's popup event: "tooltip:open"
document.addEventListener("tooltip:open", e => {
  // Set the units to "cm" every time the popup opens
  changeUnits("cm");
});